import React from 'react'
import PropTypes from 'prop-types'
import {Elevation as RmwcElevation} from '@rmwc/elevation'
import '@rmwc/elevation/styles'

const Elevation = ({children, ...otherProps}) => <RmwcElevation {...otherProps}>{children}</RmwcElevation>

Elevation.propTypes = {
  children: PropTypes.any,
  /**
   * Allows for smooth transitions between elevations when the z value changes.
   */
  transition: PropTypes.bool,
  /**
   * Allows the elevation classes to be merged onto the child component instead of creating an new DOM node.
   */
  wrap: PropTypes.bool,
  /**
   * A number from 0 - 24 for different levels of elevation
   */
  z: PropTypes.oneOfType([PropTypes.number, PropTypes.string])
}

export {Elevation}
